var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnrollListsHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "polyLogo",
    viewBox: "0 0 76.7 77",
    style: {
      enableBackground: "new 0 0 76.7 77"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.polyfill-logo{fill:#37B34A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "polytechLogo",
    className: "polyfill-logo",
    d: "M61.8,12.5c1.5,0.6,4,4.4,3.4,8.6c-2.9,2.3-6.3,3.9-9.6,4.4v26.4h9.8c0,4.1-0.6,7.3-1.3,8.5  h-18V25.9H33.7v20.5c0,10.4-5.8,15.4-13.3,15.4c-2.1,0-4.6-0.3-6.7-0.9c-1-1.3-1.5-5.3-1.6-10.3c4.9,2.4,11.6,3.5,12.2-4.2V27.2  c-7.5,0.8-10.2,6-12.8,9.5c0.1-4.7,0.3-9,0.6-11.9c5.1-5.5,10.9-8.1,22.2-8.1h16.2C54.4,16.8,58.2,15.4,61.8,12.5 M38.7,5  C24.1,5,18.2,5.9,18.2,5.9C12,6.2,7.6,10.5,6.9,17.8c0,0-1.1,9.5-1.1,20.6S6.9,59,6.9,59c0.6,7.3,5,11.6,11.3,11.9  c0,0,5.9,0.9,20.5,0.9s20.5-0.9,20.5-0.9c6.2-0.3,10.7-4.6,11.3-11.9c0,0,1.1-9.2,1.1-20.6c0-11-1.1-20.6-1.1-20.6  c-0.6-7.3-5-11.6-11.3-11.9C59.2,5.8,53.3,5,38.7,5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrollListsHeaderLogo);
export default __webpack_public_path__ + "static/media/enroll-lists-header-logo.896ee607d20586ffd1733e2462cad576.svg";
export { ForwardRef as ReactComponent };